import {
  PRESUPUESTADOR_SEARCH_PATENT_SUCCESS,
  PRESUPUESTADOR_SEARCH_PATENT_BEGIN,
  PRESUPUESTADOR_SEARCH_PATENT_FAILURE
} from '../constants';


export function reducer(state, action) {
    if (action.type === PRESUPUESTADOR_SEARCH_PATENT_BEGIN || action.type === PRESUPUESTADOR_SEARCH_PATENT_FAILURE) {
      return {
        ...state, 
        patentPending: action.data.patentPending
      }
    }
    else if (action.type === PRESUPUESTADOR_SEARCH_PATENT_SUCCESS) {
        const peritaciones = action.data?.peritaje ? 
          {
            ...state.peritaciones,
            [action.data.peritaje.servicePatent]: action.data.peritaje,
          } :
          state.peritaciones

        return {
            ...state,
            patenteReject: null,
            entregaUsados: [
              {
                oldValue: 0,
                final_take_price: action.data.peritajeQuote.appraisal,
                quotation_id: action.data.peritajeQuote.requestsId,
                year:  action.data.peritajeQuote.verification?.original_vehicle?.year?.label || action.data.peritajeQuote.verification.vehicle.year.label,
                brand: action.data.peritajeQuote.verification.vehicle.brand.label,
                model: action.data.peritajeQuote.verification.vehicle.model.label,
                version: action.data.peritajeQuote.verification?.original_vehicle?.version?.label || action.data.peritajeQuote.verification.vehicle.version.label,
                versionId: action.data.peritajeQuote.verification?.original_vehicle?.version?.value || action.data.peritajeQuote.verification.vehicle.version.value,
                km: action.data.peritajeQuote.verification.original_kilometraje || action.data.peritajeQuote.verification.kilometraje,
                appraisal: action.data.peritajeQuote.appraisal,
                peritado: action.data.peritajeQuote.verification.statusId,
                verificationDate: action.data.peritajeQuote.verification.verificationDate,
                patente: action.data.patente,
                pending: false,
                error: null,
                valid: true,
                original_price: action.data.peritajeQuote.appraisal,
                use_take_improvement: 0,
                take_improvement_amount: 0,
                version_id:action.data.peritajeQuote.verification.vehicle.version.value,
                license_plate: action.data.peritajeQuote.patente,
                requestsId: action.data.peritajeQuote.requestsId,
                verification: action.data.peritajeQuote.verification,
                appraisal_approved: action.data.peritajeQuote.appraisal_approved,
              },
            ].concat(state.entregaUsados),
          peritaciones: peritaciones,
          patentPending: action.data.patentPending
        }
      }
    else {
      return state
  }
}